const New_Password = () => (
  <div className="px-4 md:px-24 py-6">
    <div className="z-0 w-full relative flex flex-col items-start justify-center text-left font-inter">
      <div className="flex w-full justify-between items-start mt-6 md:mt-10">
        <div>
          <h2 className="text-[22px] md:text-[36px] text-[#03897B] lg:text-[47px] font-bold leading-[120%]">Check your email</h2>
          <h2 className="text-[16px] sm:text-[20px] md:text-[32px] font-semibold text-[#979797] leading-[120%] italic mt-1">A reset link was sent to your email address. Please use it to set your new password.</h2>
        </div>
      </div>
    </div>
  </div>
);
export default New_Password;